import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - Orthopedics, MCh - Spine Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Spine Surgery Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MS - Orthopedics, Fellowship in Minimally Invasive Spine Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Minimally Invasive Spine Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - Orthopedics, MCh - Neurosurgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Complex Spine Reconstruction Expert"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MS - Orthopedics, Fellowship in Spinal Deformity",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Spinal Deformity Correction Specialist"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - Orthopedics, Fellowship in Endoscopic Spine Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Endoscopic Spine Expert"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, DNB - Neurosurgery",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Spine & Neuro Surgery Specialist"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Spine Surgery Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for spinal conditions with 95% success rate. Advanced minimally invasive techniques for faster recovery.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const SpineSurgery = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Spine Surgery Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Complete Spinal Care with 95% Success Rate. Minimally Invasive Techniques for Back Pain Relief and Mobility Restoration.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Emergency Spinal Care
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>95%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Surgical Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1-6</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Hours Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>3-12</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Recovery Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>{`<3%`}</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Complication Rate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "conditions", label: "Conditions", icon: "🔍" },
              { id: "procedures", label: "Procedures", icon: "🎯" },
              { id: "techniques", label: "Techniques", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "results", label: "Results", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Spine Surgery Treatment</span>
            </h2>
          </div>

          {/* What is Spine Surgery */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Spine Surgery
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Spine surgery encompasses a range of surgical procedures designed to treat various spinal conditions 
                that cause pain, neurological symptoms, or functional limitations. Modern spine surgery focuses on 
                precision, minimal tissue disruption, and rapid recovery through advanced techniques that address 
                spinal deformities, disc problems, nerve compression, and spinal instability while preserving 
                maximum spinal function.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Advanced Technology</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Utilizing navigation systems, robotic assistance, endoscopic visualization, 
                      and minimally invasive approaches for precision and safety in spinal procedures.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Comprehensive Care</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Integrated approach including pre-operative optimization, advanced surgical techniques, 
                      and structured rehabilitation for optimal outcomes and rapid return to normal activities.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Common Spinal Conditions */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Common Spinal Conditions Treated
            </h3>

            <div className="row">
              {[
                {
                  title: "Herniated Disc", 
                  description: "Bulging or ruptured spinal disc compressing nerves, causing pain, numbness, or weakness",
                  details: "Most common reason for spine surgery"
                },
                {
                  title: "Spinal Stenosis", 
                  description: "Narrowing of spinal canal putting pressure on spinal cord and nerves",
                  details: "Often causes leg pain with walking"
                },
                {
                  title: "Spondylolisthesis", 
                  description: "Slippage of one vertebra over another, causing instability and nerve compression",
                  details: "May require fusion surgery"
                },
                {
                  title: "Degenerative Disc Disease", 
                  description: "Age-related wear and tear of spinal discs causing chronic pain and stiffness",
                  details: "Progressive condition affecting mobility"
                },
                {
                  title: "Spinal Fractures", 
                  description: "Vertebral fractures from trauma, osteoporosis, or tumors requiring stabilization",
                  details: "Often treated with minimally invasive techniques"
                },
                {
                  title: "Spinal Deformities", 
                  description: "Scoliosis, kyphosis, or other spinal curvatures affecting posture and function",
                  details: "Comprehensive correction approaches"
                }
              ].map((condition, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {condition.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {condition.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {condition.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Surgical Procedures */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Advanced Spine Surgery Procedures
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Microdiscectomy",
                    description: "Minimally invasive removal of herniated disc material compressing nerves",
                    treatment: "Gold standard for sciatica from disc herniation"
                  },
                  {
                    type: "Spinal Fusion",
                    description: "Joining two or more vertebrae together to eliminate painful motion",
                    treatment: "For instability, deformities, or severe degeneration"
                  },
                  {
                    type: "Laminectomy",
                    description: "Removal of bone (lamina) to create space and relieve nerve pressure",
                    treatment: "Effective for spinal stenosis treatment"
                  },
                  {
                    type: "Artificial Disc Replacement",
                    description: "Replacing damaged disc with artificial device preserving motion",
                    treatment: "Motion-preserving alternative to fusion"
                  },
                  {
                    type: "Vertebroplasty/Kyphoplasty",
                    description: "Minimally invasive stabilization of spinal fractures with bone cement",
                    treatment: "Rapid pain relief for vertebral fractures"
                  },
                  {
                    type: "Endoscopic Spine Surgery",
                    description: "Ultra-minimally invasive approach using tiny incisions and camera guidance",
                    treatment: "Fastest recovery with minimal tissue disruption"
                  }
                ].map((procedure, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {procedure.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {procedure.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {procedure.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Surgical Techniques */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Advanced Surgical Techniques
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Minimally Invasive Approaches</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Endoscopic spine surgery with camera guidance</li>
                      <li style={{ marginBottom: "10px" }}>Tubular retractor systems for minimal tissue disruption</li>
                      <li style={{ marginBottom: "10px" }}>Percutaneous screw placement for spinal stabilization</li>
                      <li style={{ marginBottom: "10px" }}>Laser and radiofrequency disc procedures</li>
                      <li>Navigated and robotic-assisted surgery</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Advanced Technologies</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Intraoperative navigation for precision placement</li>
                      <li style={{ marginBottom: "10px" }}>Robotic guidance systems for accuracy</li>
                      <li style={{ marginBottom: "10px" }}>Intraoperative neuromonitoring for safety</li>
                      <li style={{ marginBottom: "10px" }}>Advanced imaging integration (CT/MRI guided)</li>
                      <li>Minimal access muscle-sparing techniques</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Approaches */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Minimally Invasive Spine Surgery
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Minimally invasive spine surgery (MISS) uses specialized techniques to access the spine 
                    through smaller incisions, causing less muscle damage, reduced blood loss, and faster recovery 
                    compared to traditional open surgery.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>MISS Benefits:</h6>
                    <div className="row">
                      <div className="col-12">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}><strong>Smaller Incisions:</strong> 1-2 cm vs. 10-15 cm in open surgery</li>
                          <li style={{ marginBottom: "8px" }}><strong>Less Muscle Damage:</strong> Muscle-sparing approaches preserve function</li>
                          <li style={{ marginBottom: "8px" }}><strong>Reduced Blood Loss:</strong> Minimal bleeding during procedure</li>
                          <li style={{ marginBottom: "8px" }}><strong>Faster Recovery:</strong> Return to activities in weeks instead of months</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Common MISS Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}><strong>Microdiscectomy:</strong> For herniated discs with sciatica</li>
                      <li style={{ marginBottom: "8px" }}><strong>Minimally Invasive TLIF:</strong> Fusion for instability</li>
                      <li style={{ marginBottom: "8px" }}><strong>Endoscopic Discectomy:</strong> Ultra-minimal disc removal</li>
                      <li><strong>Minimally Invasive Decompression:</strong> For spinal stenosis</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Complex & Revision Spine Surgery
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Complex Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}><strong>Spinal Deformity Correction:</strong> Scoliosis and kyphosis surgery</li>
                      <li style={{ marginBottom: "10px" }}><strong>Revision Spine Surgery:</strong> Correcting failed previous surgeries</li>
                      <li style={{ marginBottom: "10px" }}><strong>Spinal Tumor Resection:</strong> Removing benign and malignant tumors</li>
                      <li style={{ marginBottom: "10px" }}><strong>Trauma Reconstruction:</strong> Complex spinal fracture repair</li>
                      <li><strong>Osteotomy Procedures:</strong> Correcting rigid spinal deformities</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Technologies:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>3D navigation for complex anatomy</li>
                      <li style={{ marginBottom: "10px" }}>Robotic assistance for precision</li>
                      <li style={{ marginBottom: "10px" }}>Intraoperative CT scanning</li>
                      <li style={{ marginBottom: "10px" }}>Neuromonitoring for neural safety</li>
                      <li>Customized implants and instrumentation</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Multidisciplinary Approach:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Collaboration with pain management specialists</li>
                      <li style={{ marginBottom: "10px" }}>Integrated physical therapy and rehabilitation</li>
                      <li>Comprehensive pre-operative optimization</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Recovery Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgery & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Initial Recovery",
                    activities: ["Hospital stay 1-3 days", "Pain management", "Early mobilization", "Wound care"]
                  },
                  {
                    period: "Week 3-6",
                    title: "Rehabilitation Phase",
                    activities: ["Physical therapy begins", "Gradual activity increase", "Walking program", "Core strengthening"]
                  },
                  {
                    period: "Month 2-3",
                    title: "Functional Recovery",
                    activities: ["Return to light work", "Driving resumption", "Increased activities", "Therapy progression"]
                  },
                  {
                    period: "Month 4-6",
                    title: "Full Recovery",
                    activities: ["Return to all activities", "Sports participation", "Full strength", "Optimal function"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Aftercare & Rehabilitation */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Post-operative Care & Rehabilitation
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Immediate Post-op Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Pain management with prescribed medications</li>
                      <li style={{ marginBottom: "10px" }}>Incision care and monitoring for infection</li>
                      <li style={{ marginBottom: "10px" }}>Early mobilization with physical therapy guidance</li>
                      <li>Activity restrictions and proper body mechanics education</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Rehabilitation</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Structured physical therapy program</li>
                      <li style={{ marginBottom: "10px" }}>Core strengthening and stabilization exercises</li>
                      <li style={{ marginBottom: "10px" }}>Gradual return to activities and sports</li>
                      <li>Lifestyle modifications for spinal health maintenance</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How painful is spine surgery and recovery?",
                  answer: "Spine surgery is performed under general anesthesia, so you won't feel any pain during the procedure. After surgery, pain is carefully managed with a multi-modal approach including medications, regional anesthesia techniques, and non-pharmacological methods. Most patients describe the post-operative pain as manageable and significantly different from their pre-surgery pain. The first 2-3 days typically involve the most discomfort, which then gradually improves. Modern minimally invasive techniques have dramatically reduced post-operative pain compared to traditional open surgery. Your pain management team will work closely with you to ensure your comfort throughout the recovery process. Most patients are pleasantly surprised by how well their pain is controlled and how quickly they can reduce their pain medication needs."
                },
                {
                  question: "How long does it take to recover from spine surgery?",
                  answer: "Recovery time varies significantly based on the type of spine surgery performed: Minimally Invasive Discectomy: 2-6 weeks for full recovery; Spinal Fusion: 3-6 months for bone healing and full recovery; Laminectomy: 4-8 weeks for return to normal activities; Artificial Disc Replacement: 6-12 weeks for complete recovery; Complex Deformity Surgery: 6-12 months for full rehabilitation. Most patients can return to sedentary work within 2-4 weeks and more physically demanding jobs within 3-6 months. The recovery process involves: Initial healing phase (2-6 weeks), Rehabilitation phase (6 weeks - 3 months), Strengthening phase (3-6 months), and Maintenance phase (6+ months). Your specific recovery timeline will be tailored to your procedure, overall health, and rehabilitation progress."
                },
                {
                  question: "What is the success rate of spine surgery?",
                  answer: "Spine surgery success rates are generally high when performed for appropriate indications by experienced surgeons: Microdiscectomy: 90-95% success rate for leg pain relief; Laminectomy: 85-90% success for spinal stenosis symptoms; Spinal Fusion: 80-90% success for appropriate instability cases; Artificial Disc Replacement: 85-90% success for motion preservation; Minimally Invasive Procedures: 90-95% success with faster recovery. Success is measured by: Significant pain reduction; Improved function and mobility; Return to desired activities; Patient satisfaction; Achievement of surgical goals. Factors influencing success include: Proper patient selection; Accurate diagnosis; Surgical technique and experience; Patient compliance with rehabilitation; Addressing underlying health factors. Modern techniques and advanced technology have significantly improved success rates and reduced complications."
                },
                {
                  question: "What are the risks and complications of spine surgery?",
                  answer: "While spine surgery is generally safe, all surgical procedures carry some risks. Potential complications include: General Surgical Risks: Infection, bleeding, blood clots, anesthesia complications; Specific Spine Surgery Risks: Nerve injury, dural tear (leak of spinal fluid), hardware failure, non-union (fusion not healing), adjacent segment disease, persistent pain. The overall complication rate for spine surgery is 2-5% in experienced hands. Modern safety measures significantly reduce these risks: Intraoperative navigation for precision; Neuromonitoring to protect nerves; Antibiotic protocols to prevent infection; Advanced hemostatic techniques to control bleeding; Minimally invasive approaches to reduce tissue damage. Your surgical team will discuss your specific risks based on your health condition and the planned procedure, and will implement comprehensive strategies to minimize these risks throughout your surgical journey."
                },
                {
                  question: "Will I need physical therapy after spine surgery?",
                  answer: "Yes, physical therapy is a crucial component of recovery after most spine surgeries. The rehabilitation program is typically phased: Early Phase (0-6 weeks): Focus on wound healing, gentle mobility, and pain management; Intermediate Phase (6 weeks - 3 months): Progressive strengthening, flexibility, and functional training; Advanced Phase (3-6 months): Sport-specific training, advanced strengthening, and return to activities; Maintenance Phase (6+ months): Ongoing exercises to maintain spinal health. Physical therapy helps: Restore range of motion and flexibility; Strengthen core and supporting muscles; Improve posture and body mechanics; Facilitate safe return to activities; Prevent future spinal problems. The specific therapy program is customized based on your surgical procedure, fitness level, and goals. Most patients continue some form of spinal exercises indefinitely to maintain their surgical results and prevent future issues."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Need Spine Surgery Consultation?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert team provides advanced spine surgery with 95% success rate and comprehensive recovery support.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Spine Surgery: <strong>080-6541-7705</strong> | Neurosurgery: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default SpineSurgery;